import { ItemCategoryInfoList } from "./const";
import { ItemCategory } from "./enum/enum";

export const FilteredItemCategoryList = [
  ItemCategoryInfoList[ItemCategory.CASH],
  ItemCategoryInfoList[ItemCategory.BULLET],
  ItemCategoryInfoList[ItemCategory.FBI_ASSETS],
  ItemCategoryInfoList[ItemCategory.CREDIT],
];
